import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import BlankZeroMenuItem from "../../../common/fields/field-options/BlankZeroMenuItem.tsx";
import OtherOptionsWrapper from "../../../common/fields/field-options/OtherOptionsWrapper.tsx";
import ReverseSignMenuItem from "../../../common/fields/field-options/ReverseSignMenuItem.tsx";

interface Props {
  measure: ReportField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}
const OtherOptionsComponent = ({ measure, saveChanges, readonly }: Props) => (
  <OtherOptionsWrapper>
    <BlankZeroMenuItem field={measure} saveChanges={saveChanges} readonly={readonly} />
    <ReverseSignMenuItem field={measure} saveChanges={saveChanges} readonly={readonly} />
  </OtherOptionsWrapper>
);

export default OtherOptionsComponent;
